import TextIcon from "@assets/disco/icons/ai/write-with-ai.svg"
import { DiscoCustomIcon } from "@disco-ui"

const AIEditorWrite = () => {
  return <DiscoCustomIcon icon={<TextIcon />} height={28} width={28} />
}

export default AIEditorWrite
